import LiabilityTabControls from "../liability/LiabilityTabControls"
import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import WorkersCompDetails from "./WorkersCompDetails"

const WorkersCompTab = ({ inWorkQ }) => {
    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Worker’s Comp</h2>
                <NotesComponent noteTypeId={8} inWorkQ={inWorkQ}/>
            </div>
            <LiabilityTabControls folder={'worker_comp'} apiCase={'case_worker_comp'}/>
        </TabHeader>
        <WorkersCompDetails />
    </>
}

export default WorkersCompTab